import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "@/components/primitives";
import { Cta } from "@/components/Cta";
import { ASSESSMENT_CHECKLIST } from "@/data/content";

export default function AssessmentCTA() {
    return (
        <section className="py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <div className="grain relative overflow-hidden rounded-[2rem] border border-white/10 bg-brand p-10 text-white md:p-16">
                        <div
                            aria-hidden
                            className="pointer-events-none absolute inset-0 opacity-50"
                            style={{
                                backgroundImage:
                                    "radial-gradient(circle at 82% 18%, rgba(255,255,255,0.22), transparent 45%), radial-gradient(circle at 8% 92%, rgba(0,0,0,0.35), transparent 55%)",
                            }}
                        />
                        <div className="relative grid gap-12 lg:grid-cols-12 lg:items-center">
                            <div className="lg:col-span-7">
                                <span className="font-mono text-xs uppercase tracking-[0.22em] text-white/60">
                                    AI Automation Assessment
                                </span>
                                <h2 className="mt-5 text-balance text-4xl font-bold leading-[1.08] tracking-tight md:text-5xl">
                                    Book a free AI automation assessment
                                </h2>
                                <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70">
                                    We&apos;ll spend time understanding your
                                    operation, identifying repetitive workflows,
                                    and highlighting where AI can create
                                    measurable value.
                                </p>
                                <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
                                    <Cta
                                        to="/contact"
                                        size="lg"
                                        variant="navy"
                                        testId="assessment-cta"
                                        withArrow={false}
                                        className="bg-white text-brand hover:shadow-[0_16px_40px_-12px_rgba(255,255,255,0.4)]"
                                    >
                                        Schedule Assessment
                                    </Cta>
                                    <span className="font-mono text-xs uppercase tracking-[0.16em] text-white/50">
                                        No obligation · Just practical advice
                                    </span>
                                </div>
                            </div>

                            <div className="lg:col-span-4 lg:col-start-9">
                                <div className="rounded-2xl border border-white/12 bg-white/5 p-7 backdrop-blur-sm">
                                    <h3 className="font-mono text-xs uppercase tracking-[0.18em] text-white/60">
                                        What we cover
                                    </h3>
                                    <ul className="mt-5 space-y-4">
                                        {ASSESSMENT_CHECKLIST.map((item, i) => (
                                            <motion.li
                                                key={item}
                                                initial={{ opacity: 0, x: -8 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                viewport={{ once: true }}
                                                transition={{
                                                    duration: 0.5,
                                                    ease: [0.16, 1, 0.3, 1],
                                                    delay: i * 0.08,
                                                }}
                                                className="flex items-center gap-3"
                                            >
                                                <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-white/15">
                                                    <Check
                                                        className="h-3 w-3"
                                                        strokeWidth={2.5}
                                                    />
                                                </span>
                                                <span className="text-[15px] text-white/90">
                                                    {item}
                                                </span>
                                            </motion.li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
